import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { HugeiconsIcon } from '@hugeicons/react';
import { Copy01Icon, Tick02Icon } from '@hugeicons/core-free-icons';
import { CopyTooltip } from './CopyTooltip';
import { useCopyFeedback } from './useCopyFeedback';
export function CopyButton({ label, copyText, staticCopyText, writeClipboard, wrapCopyButton, onCopyError, onCopy, className = 'oq-issue-item__copy-btn oq-detail-card__copy' }) {
    const { copy, copied, failed } = useCopyFeedback(async () => {
        const text = copyText();
        if (writeClipboard)
            await writeClipboard(text);
        else
            await navigator.clipboard.writeText(text);
    }, err => {
        console.error('[CopyButton] copy failed for', label, err instanceof Error ? err.message : String(err));
        onCopyError?.(err);
    });
    const handleCopy = (e) => {
        // Inside a <summary> the click must not toggle the disclosure the button sits in.
        e.preventDefault();
        e.stopPropagation();
        onCopy?.();
        void copy();
    };
    const bare = (_jsx("button", { type: "button", className: className, onClick: handleCopy, "aria-label": label, "data-copy-element": staticCopyText, children: _jsx(HugeiconsIcon, { icon: copied ? Tick02Icon : Copy01Icon, size: 14, strokeWidth: 2, color: "currentColor" }) }));
    if (staticCopyText !== undefined)
        return bare;
    if (wrapCopyButton)
        return _jsx(_Fragment, { children: wrapCopyButton(bare, label, copied) });
    return _jsx(CopyTooltip, { label: label, copied: copied, failed: failed, children: bare });
}
//# sourceMappingURL=CopyButton.js.map